import type { EggStyle, Topping, WaffleKind } from '../game/types';
import {
  baconIcon,
  coffeeIcon,
  eggIcon,
  hashBrownIcon,
  toppingIcon,
  waffleKindIcon,
} from '../render/icons';
import { createCanvas, ctx2d, type Sprite } from '../render/sprite';
import { h } from './dom';

/*
 * Pixel icons as <img> elements backed by cached data URLs, so tickets and
 * buttons can reuse them freely without juggling canvases.
 */

const urls = new WeakMap<Sprite, string>();

export function spriteUrl(sprite: Sprite, zoom = 2): string {
  const hit = urls.get(sprite);
  if (hit) return hit;
  const c = createCanvas(sprite.w * zoom, sprite.h * zoom);
  const ctx = ctx2d(c);
  ctx.drawImage(sprite.canvas, 0, 0, sprite.w * zoom, sprite.h * zoom);
  const url = c.toDataURL('image/png');
  urls.set(sprite, url);
  return url;
}

export function iconImg(sprite: Sprite, className: string, alt = ''): HTMLImageElement {
  return h('img', {
    class: className,
    src: spriteUrl(sprite),
    alt,
    draggable: 'false',
    width: sprite.w * 2,
    height: sprite.h * 2,
  });
}

export const ICONS = {
  topping: (t: Topping): Sprite => toppingIcon(t),
  hashBrowns: (): Sprite => hashBrownIcon(),
  waffle: (k: WaffleKind): Sprite => waffleKindIcon(k),
  eggs: (s: EggStyle): Sprite => eggIcon(s),
  bacon: (): Sprite => baconIcon(),
  coffee: (): Sprite => coffeeIcon(),
};
